<script>
export default {
  data() {
    return {
      videoFlag: 0,
      pageFlag: 'Home',
      Function_Intro: [{
        title: '功能设计：数据流',
        detail: '离线数据流与实时数据流。覆盖从前端的用户行为埋点、日志记录到离线端的日志流式处理、数据仓库存储，再到实时端的数据缓存、离线—实时两端的数据共享，实现全流程的数据治理功能。',
        imgPath: require('@/assets/function1.png')
      }, {
        title: '功能设计：基本业务流',
        detail: '推荐系统的业务逻辑是一个管道线，包括召回、粗排和重排等步骤，它们可以从大规模的候选物品集中，逐步缩小计算空间，优化物品排序，提高推荐列表的准确性。',
        imgPath: require('@/assets/function2.png')
      }, {
        title: '能力构建：推荐系统的新范式→沈阳•太一 (v2.0)',
        detail: '拆分为通用的用户画像模块、物品表示模块、推荐生成模块等三大子模块，便于将预训练好的用户和物品表示模块迁移到其他不同的应用领域，实现通用的推荐解决方案。\n',
        imgPath: require('@/assets/function3.png')
      }],
      playerOptions: [
        {
          playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("@/assets/DEMO1.mp4") // url地址
          }],
          poster: './assets/logo.png', // 你的封面地址
          width: document.documentElement.clientWidth, // 播放器宽度
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true // 全屏按钮
          }
        }, {
          playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("@/assets/DEMO2.mp4") // url地址
          }],
          poster: './assets/logo.png', // 你的封面地址
          width: document.documentElement.clientWidth, // 播放器宽度
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true // 全屏按钮
          }
        },
        {
          playbackRates: [0.7, 1.0, 1.5, 2.0], // 播放速度
          autoplay: false, // 如果true,浏览器准备好时开始回放。
          muted: false, // 默认情况下将会消除任何音频。
          loop: false, // 导致视频一结束就重新开始。
          preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
          language: 'zh-CN',
          aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
          fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
          sources: [{
            type: 'video/mp4', // 这里的种类支持很多种：基本视频格式、直播、流媒体等，具体可以参看git网址项目
            src: require("@/assets/DEMO3.mp4") // url地址
          }],
          poster: './assets/logo.png', // 你的封面地址
          width: document.documentElement.clientWidth, // 播放器宽度
          notSupportedMessage: '此视频暂无法播放，请稍后再试', // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
          controlBar: {
            timeDivider: true,
            durationDisplay: true,
            remainingTimeDisplay: false,
            fullscreenToggle: true // 全屏按钮
          }
        }
      ],
    }
  },
  methods:{
    GoDemoAPI(flag){
      if(flag===0){
        window.open("https://www.baidu.com/")
      }else if(flag===1){
        window.open("https://www.bilibili.com/")
      }else{
        window.open("https://www.baidu.com/")
      }
    }
  }
}
</script>

<template>
  <el-container>
    <el-header>
      <div class="myHead">
        <el-button type="text" class="el-dropdown-link" @click="pageFlag='Home'">主页</el-button>
        <el-button type="text" class="el-dropdown-link" style="margin-left: 30px">资源</el-button>
        <el-button type="text" class="el-dropdown-link" style="margin-left: 30px">文档</el-button>
        <el-button type="text" class="el-dropdown-link" style="margin-left: 30px">数据集</el-button>
        <el-button type="text" class="el-dropdown-link" style="margin-left: 30px" @click="pageFlag='AboutUs'">关于我们
        </el-button>
      </div>
    </el-header>
    <el-main>
      <div v-if="pageFlag==='Home'">
        <div class="poster">
          <div class="leftCharacterBox">
            <p class="one">沈阳·太一</p>
            <p class="one">多模态推荐大模型</p>
            <div class="two">
              &nbsp;&nbsp;沈阳·太一是由数据科学团队开发的辽宁省首个基础大模型，填补国内在搜索推荐领域大模型的空白。

            </div>
            <div class="two">
              &nbsp;&nbsp;模型基于Pytorch、国产昇腾AI硬件和昇思MindSpore
              AI框架开发，提供“预训练大模型+下游任务微调”的通用AI解决方案，将多种推荐任务统一于共享框架中，支持文本、图像、语音、知识图谱等多模态信息输入，实现多种推荐任务统一、个性化精准推荐。目前支持Pytorch和MindSpore两个版本。
            </div>

<!--            <div class="btn">-->
<!--              <el-button class="a">东北大学数据科学团队</el-button>-->
<!--              <a class="text">&</a>-->
<!--              <el-button class="b">沈阳华为昇腾</el-button>-->
<!--            </div>-->
          </div>
          <div class="rightCharacterBox">
            <p style="color: #E8F2FF;font-family: PingFang SC, serif;font-size: 32px;font-style: normal;font-weight: bold;line-height: 42px;margin: 0">
              沈阳·太一 <b>TheOne</b></p>
            <div
                style="color: #A7BAF0;text-align: right;font-family: PingFang SC, serif;font-size: 24px;font-style: normal;font-weight: 400;line-height: 48px; /* 200% */">
              礼必本于太一，分而为天地，转而为阴阳，变而为四时。
              -《礼记·礼运》
            </div>
          </div>
        </div>

        <div class="context">
          <div class="ct1">
            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;
        line-height: 60px; /* 150% */letter-spacing: 0.4px;">功能介绍
            </div>
            <div class="content">
              <el-carousel trigger="click" height="670px">
                <el-carousel-item v-for="item in Function_Intro" :key="item">
                  <div class="logo">
                    <div style="text-align: left">
                      <span style="color: #1E34BA;font-weight: bold">TheOne</span>
                      <el-divider direction="vertical"></el-divider>
<!--                      <img src="@/assets/content_logo.png" alt="" width="60" height="21"/>-->
                      <span>{{ item.title }}</span>
                    </div>
                  </div>
                  <img :src="item.imgPath" alt="" height="450"/>
                  <p class="content2_Detail">{{ item.detail }}</p>
                </el-carousel-item>
              </el-carousel>

            </div>
          </div>

          <div class="ct2">
            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;
        line-height: 60px; /* 150% */letter-spacing: 0.4px;">整体架构
            </div>
            <div class="content">
              <p>辽宁省首个基础大模型，旨在填补国内在搜索推荐领域的大模型空白。</p>
              <img src="@/assets/constructure.png" alt="" style="margin-top: 3%">

            </div>
          </div>

          <div class="ct6">
            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;
        line-height: 60px; /* 150% */letter-spacing: 0.4px;">技术优势
            </div>
            <div class="content">
              <div class="imgBlock">
                <img src="@/assets/Advanture1.png" alt="" style="margin-left: 3%"/>
                <img src="@/assets/Advanture2.png" alt="" style="margin-left: 3%"/>
                <img src="@/assets/Advanture3.png" alt="" style="margin-left: 3%"/>
                <img src="@/assets/Advanture4.png" alt="" style="margin-left: 3%"/>
              </div>
              <div class="ct6_detail">
                <div style="margin-left: 3%">
                  <p class="ct6_title">模态丰富</p>
                  <div class="ct6_content">模型支持文字、图片、音频、视频、社交关系、知识图谱、用户信息、物品信息等多种模态。
                  </div>
                </div>
                <div style="margin-left: 3%">
                  <p class="ct6_title">预训练＋微调模式</p>
                  <div class="ct6_content">模型可以结合具体需求提供服务，并支持在耗费较少算力资源的前提下发挥大模型的能力。
                  </div>
                </div>
                <div style="margin-left: 3%">
                  <p class="ct6_title">通用可迁移</p>
                  <div class="ct6_content">模型可以摆脱对单一数据集或特定数据集的依赖，将知识迁移应用于多种场景之中。
                  </div>
                </div>
                <div style="margin-left: 3%">
                  <p class="ct6_title">兼顾个性化 </p>
                  <div class="ct6_content">由于模型考虑用户信息，故能在各种下游场景中综合特定用户偏好提供针对性服务。
                  </div>
                </div>

              </div>
            </div>
          </div>

          <!--          <div class="ct3">-->
          <!--            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;-->
          <!--        line-height: 60px; /* 150% */letter-spacing: 0.4px;">模块划分-->
          <!--            </div>-->
          <!--            <div class="content">-->
          <!--              <el-row>-->
          <!--                <el-col :span="8">-->
          <!--                  <el-card style="width: 380px;height: 340px;border-radius: 8px;">-->
          <!--                    <img src="@/assets/icon4.png" alt="" width="60" height="60" style="margin-top: 5%"/>-->
          <!--                    <p class="a">01 通用用户表示 </p>-->
          <!--                    <div class="b">-->
          <!--                      用户属性：融合属性信息，理解群体偏好预测属性生成画像。用户行为：采集交互序列，预测后续行为， 提供决策建议。-->
          <!--                    </div>-->
          <!--                  </el-card>-->
          <!--                </el-col>-->
          <!--                <el-col :span="8">-->
          <!--                  <el-card-->
          <!--                      style="width: 380px;height: 340px;border-radius: 8px;background: linear-gradient(180deg, #1E34BA 68.05%, rgba(30, 52, 186, 0.00) 336%);">-->
          <!--                    <img src="@/assets/icon5.png" alt="" width="60" height="60" style="margin-top: 5%"/>-->
          <!--                    <p class="a1">02 通用物品表示 </p>-->
          <!--                    <div class="b1">-->
          <!--                      模态信息：采集、处理物品描述信息，融和多模态物品特征，根据场景灵活控制使用模态。-->
          <!--                    </div>-->
          <!--                  </el-card>-->
          <!--                </el-col>-->
          <!--                <el-col :span="8">-->
          <!--                  <el-card style="width: 380px;height: 340px;border-radius: 8px;">-->
          <!--                    <img src="@/assets/icon6.png" alt="" width="60" height="60" style="margin-top: 5%"/>-->
          <!--                    <p class="a">03 推荐生成 </p>-->
          <!--                    <div class="b">-->
          <!--                      垂直领域专有人物／基础模态通用人物，预测属性生成画像。-->
          <!--                      推荐系统／会话式推荐，信息检索／物品匹配，个性化生成。-->
          <!--                    </div>-->
          <!--                  </el-card>-->
          <!--                </el-col>-->
          <!--              </el-row>-->
          <!--            </div>-->

          <!--          </div>-->

          <div class="ct4">
            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;
        line-height: 60px; /* 150% */letter-spacing: 0.4px;">应用场景
            </div>
            <div class="content">
              <div style="width: 600px">
                <el-row>
                  <el-card class="cardDetail" shadow="hover" @click.native="videoFlag=0">
                    <el-col :span="6">
                      <el-button circle class="videoBtn">1</el-button>
                    </el-col>
                    <el-col :span="18">
                      <div style="margin-left: 5%">
                        <div class="a">视觉问答<el-button class="video_url_button" round @click="GoDemoAPI(0)">立即体验</el-button>
                        </div>
                        <div class="b">视觉问答，根据图片进行问答,提供视觉问答功能，根据图片等视觉信息进行问答。</div>
                      </div>
                    </el-col>
                  </el-card>
                </el-row>
                <el-row>
                  <el-card class="cardDetail" shadow="hover" @click.native="videoFlag=1">
                    <el-col :span="6">
                      <el-button circle class="videoBtn">2</el-button>
                    </el-col>
                    <el-col :span="18">
                      <div style="margin-left: 5%">
                        <div class="a">多模态检索<el-button class="video_url_button" round @click="GoDemoAPI(1)">立即体验</el-button></div>
                        <div class="b">提供不同模态的相互检索功能，包括图检索，图文检索等。</div>
                      </div>
                    </el-col>
                  </el-card>
                </el-row>
                <el-row>
                  <el-card class="cardDetail" shadow="hover" @click.native="videoFlag=2">
                    <el-col :span="6">
                      <el-button circle class="videoBtn">3</el-button>
                    </el-col>
                    <el-col :span="18">
                      <div style="margin-left: 5%">
                        <div class="a">论文推荐<el-button class="video_url_button" round @click="GoDemoAPI(2)">立即体验</el-button></div>
                        <div class="b">在学术场景下提供推荐功能，根据用户检索内容、用户交互历史、论文关系给出个性化推荐。
                        </div>
                      </div>
                    </el-col>
                  </el-card>
                </el-row>
              </div>

              <div class="video">
                <video-player class="video-player" ref="videoPlayer" :playsline="false"
                              :options="playerOptions[0]" v-if="videoFlag===0"></video-player>
                <video-player class="video-player" ref="videoPlayer" :playsline="false"
                              :options="playerOptions[1]" v-if="videoFlag===1"></video-player>
                <video-player class="video-player" ref="videoPlayer" :playsline="false"
                              :options="playerOptions[2]" v-if="videoFlag===2"></video-player>
              </div>
<!--              <div style="margin-top: 30%">-->
<!--                <el-button class="video_url_button" round @click="GoDemoAPI()">立即体验</el-button>-->
<!--              </div>-->


            </div>
          </div>

          <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: 1000;
                    line-height: 60px; /* 150% */letter-spacing: 0.4px;margin-top: 3%">版本历程
          </div>

          <div class="ct5">
            <div class="content">
              <div class="a">
                <div class="processDetailUp" style="margin-left: 5%">
                  <div class="p1">2022/8/30</div>
                  <div class="p2">灵感初生</div>
                  <div class="p3">开始筹划立项以及模型设计。</div>

                </div>
                <div class="processDetailUp" style="margin-left: 5%">
                  <div class="p1">2023/5</div>
                  <div class="p2">V1.0完成</div>
                  <div class="p3">V1.0开发完成,5亿参数base。</div>
                </div>
                <div class="processDetailUp" style="margin-left: 5%">
                  <div class="p1">2023/5</div>
                  <div class="p2">10亿级参数</div>
                  <div class="p3">10亿级参数完成，支持图文输入、两种推荐任务。完成MindSpore到Pytorch迁移。</div>
                </div>
                <div class="processDetailUp" style="margin-left: 5%">
                  <div class="p1">2023/10</div>
                  <div class="p2">模型拓展</div>
                  <div class="p3">V1.2开发完成，完成音频、视频模态编码器。理论支持266亿参数训练。</div>
                </div>

              </div>

              <div class="b">
                <div class="processDetailDown" style="margin-left: 20%">
                  <div class="p1">2022/10</div>
                  <div class="p2">团队建立</div>
                  <div class="p3">完成初版模型结构设计， 并开始开发。</div>
                </div>
                <div class="processDetailDown" style="margin-left: 10%">
                  <div class="p1">2023/5</div>
                  <div class="p2">微调能力</div>
                  <div class="p3">太一V1.1完成，具备训练+微调能力。</div>
                </div>
                <div class="processDetailDown" style="margin-left: 10%">
                  <div class="p1">2023/9</div>
                  <div class="p2">下游拓展</div>
                  <div class="p3">初步引入检索类任务。</div>
                </div>
                <div class="processDetailDown" style="margin-left: 10%">
                  <div
                      style="color: #1F1F5B;font-family: PingFang SC,serif;font-size: 20px;font-style: normal;font-weight: 500;line-height: normal;text-align: left">
                    未来
                  </div>
                  <div
                      style="color: #02B779;font-family: PingFang SC,serif;font-size: 28px;font-style: normal;font-weight: 400;line-height: normal;text-align: left">
                    未完待续
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="pageFlag==='AboutUs'">
        <div class="About_context">
          <div class="About_ct1">
            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;
        line-height: 60px; /* 150% */letter-spacing: 0.4px;">关于我们
            </div>
            <div
                style="color: #637096;font-family: Source Sans 3;font-size: 20px;font-style: normal;font-weight: 400;line-height: normal;margin-top: 1%">
              礼本于太一，分而为天地。诚邀四海同仁，共赴AI时代！
            </div>
            <div class="content">
              <el-row>
                <el-col :span="14">
                  <div>
                    <div class="ct1_leftUp">
                      <img src="@/assets/Guo.png" alt="" width="134" height="190"/>
                      <div style="margin-left: 20px">
                        <div
                            style="color: #1F1F5B;font-family: Manrope;font-size: 24px;font-style: normal;font-weight: 600;line-height: 32.408px;text-align: left /* 124.645% */">
                          模型创始人
                        </div>
                        <p style="color: #1F1F5B;font-family: Manrope;font-size: 30px;font-style: normal;font-weight: 500;line-height: 32.408px;text-align: left  /* 101.274% */">
                          郭贵冰</p>
                        <div
                            style="color: #637096;font-family: Manrope;font-size: 18px;font-style: normal;font-weight: 500;line-height: 36px; /* 180% */letter-spacing: -0.4px;text-align: left ">
                          东北大学长聘教授，博导
                        </div>
                        <div
                            style="color: #637096;font-family: Manrope;font-size: 18px;font-style: normal;font-weight: 500;line-height: 36px; /* 180% */letter-spacing: -0.4px;text-align: left ">
                          辽宁省优秀青年基金获得者
                        </div>
                      </div>
                    </div>

                    <div class="ct1_leftBottom">
                      <p style="color: #1F1F5B;font-family: Manrope;font-size: 20px;font-style: normal;font-weight: 600;line-height: 32.408px; /* 135.032% */letter-spacing: -0.48px;text-align: left">
                        辽宁省智能互联网理论与应用重点实验室</p>
                      <div>
                        ·2023，获批辽宁省自然科学基金优秀青年基金项目<br/>
                        ·2002，入选百度学术发布的全球首份 AI青年学者榜（数据挖掘领域）<br/>
                        ·2022，辽宁省自然科学学术成果奖学术论文类二等奖<br/>
                        ·2021，2021年辽宁省优秀硕士学位论文指导教师<br/>
                        ·2019，2019年入选辽宁省第13批“百千万人才工程”<br/>
                        ·2016，获CCF国际会议IEEE ICTAI 2016最佳学生论文奖<br/>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col :span="10">
                  <div>
                    <div class="ct1_rightUp">
                      <p class="Team">模型合作团队</p>
                      <div class="Team_detail">
                        <img src="@/assets/Huawei_Logo.png" alt="">
                        <span>华为昇腾众智计划 :</span>
                      </div>
                      <div class="Team_content">建立国产可控的工业级人工智能（深度学习）计算平台。</div>
                      <div class="Team_detail">
                        <img src="@/assets/NumberTeam_Logo.png" alt="">
                        <span>数据科学团队 :</span>
                      </div>
                      <div class="Team_content">深度参与众智项目，储备了大量的技术人才。团队荣获华为“众智星光奖”。</div>
                    </div>

                    <div class="ct1_rightBottom">
                      <p class="Team">模型研发团队</p>
                      <div style="display: flex;flex-direction: row;justify-content: center;align-items: center">
                        <div>
                          <p class="developTeam">
                            <img src="@/assets/About_ct1_1.png" alt="" width="24" height="24"/>
                            <span>指导教师：教授1人，副教授1人</span>
                          </p>
                          <p class="developTeam">
                            <img src="@/assets/About_ct1_2.png" alt="" width="24" height="24"/>
                            <span>核心开发人员：硕士11人</span>
                          </p>
                          <p class="developTeam">
                            <img src="@/assets/About_ct1_3.png" alt="" width="24" height="24"/>
                            <span>技术支持：博士2人，硕士2人</span>
                          </p>
                          <p class="developTeam">
                            <img src="@/assets/About_ct1_4.png" alt="" width="24" height="24"/>
                            <span>其他开发人员：本科生若干</span>
                          </p>
                        </div>
                        <img src="@/assets/Teamhonor.jpg" alt="" width="200" style="margin-left: 5%"/>
                      </div>


                    </div>
                  </div>

                </el-col>
              </el-row>

            </div>

          </div>

          <div class="ct3_ContactUs">
            <div style="font-weight: bold;color: #FFFFFF;font-size: 24px;width: 260px">
              问题反馈
            </div>
            <p style="color: #B0BDE8;font-family: Manrope;font-size: 20px;font-style: normal;font-weight: 500;line-height: 42px;text-align: left /* 190.909% */">
              如果您关于大模型有任何的反馈或建议，欢迎发邮件至 <span style="color: #FFD978">guoguibing＠gmail.com，</span> <br/>如果您发现任何错误或问题，请随时向问题性能报告提出。我们热忱的欢迎您为太一大模型贡献代码！
            </p>
          </div>

          <div class="About_ct2">
            <div style="color: #1F1F5B;text-align: center;font-family: PingFang SC, serif;font-size: 40px;font-style: normal;font-weight: bold;
        line-height: 60px; /* 150% */letter-spacing: 0.4px;">联系我们
            </div>
            <div
                style="color: #637096;font-family: Source Sans 3;font-size: 20px;font-style: normal;font-weight: 400;line-height: normal;margin-top: 1%">
              礼本于太一，分而为天地。诚邀四海同仁，共赴AI时代！
            </div>
            <div class="content">
              <el-card class="About_ct2_card">
                <div class="About_ct2_left">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;太一，即最大的宇宙。宇宙并不是一个静态的固定边界结构，而是一个半开放的不断壮大的生态。沈阳·太一模型亦是如此。为了促进沈阳·太一大模型的持续改进和更好地服务推荐系统社区，需要一个协同合作、共同奋进的团队。欢迎有志于从事开源推荐事业的梦想人士加入我们的团队。有意向的朋友可发个人简历到我的邮箱：
                  guogb@swc.neu.edu.cn，或加微信了解更多，非诚勿扰。 本招募信息长期有效，欢迎志同道合的人士积极参与，为开源推荐系统贡献自己的一份力。
                </div>
                <br/>
                <div
                    style="color: #1F1F5B;font-family: Manrope;font-size: 20px;font-style: normal;font-weight: 500;line-height: 32.408px; /* 147.307% */letter-spacing: -0.44px;text-align: right">
                  —沈阳·太一大模型创始人 郭贵冰
                </div>
              </el-card>
              <el-card class="About_ct2_card" style="margin-left: 5%">
                <div
                    style="color: #1F1F5B;font-family: Manrope;font-size: 26px;font-style: normal;font-weight: 500;line-height: 32.408px; /* 108.025% */">
                  团队招募
                </div>
                <div class="About_ct2_left" style="margin-top: 10px">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;如果您对沈阳·太一大模型有兴趣并希望助力模型发展，欢迎通过以下方式联系团队！</div>

                <div style="display: flex;flex-direction: row;justify-content: center;align-items: center">
                  <div>
                    <p class="contribution">微信</p>
                    <img src="@/assets/WeiXin.png" alt="" width="120" height="120"/>
                  </div>
                  <div style="margin-left: 20px">
                    <p class="contribution">微博</p>
                    <img src="@/assets/AliPay.png" alt="" width="120" height="120"/>
                  </div>
                  <div style="margin-left: 20px">
                    <p class="contribution">github</p>
                    <img src="@/assets/github.png" alt="" width="120" height="120"/>
                  </div>
                </div>
              </el-card>

            </div>
          </div>


        </div>
      </div>

    </el-main>

    <el-footer>
      <div class="footer">
        <div style="margin:0 10%;display: flex;flex-direction: row;justify-content: space-between;height: 100px">
          <div class="detail" style="font-weight: bold">Follow us :</div>
          <div style="display: flex">
            <div class="detail">via Gitter</div>
            <!--            <a href="https://www.baidu.com/" style="margin-left: 5%">-->
            <img src="@/assets/gitter.png" alt="" width="80" height="80" style="margin-left: 5%"/>
            <!--            </a>-->
          </div>
          <div style="display: flex">
            <div class="detail">via Weibo</div>
            <!--            <a href="https://www.baidu.com/" style="margin-left: 5%">-->
            <img src="@/assets/Weibo.png" alt="" width="80" height="80" @click="" style="margin-left: 5%"/>
            <!--            </a>-->
          </div>
          <div style="display: flex">
            <div class="detail">via WeChat</div>
            <img src="@/assets/Wechat.png" alt="" width="80" height="80" style="margin-left: 5%"/>
          </div>

        </div>
        <el-divider></el-divider>
        <div>
          <p style="color: #FFF;font-family: Manrope;font-size: 12px;font-style: normal;font-weight: 500;line-height: 26px;margin-bottom: 5px /* 216.667% */">
            2023 All Rights Reserved-Shenyangtaiyi.&nbsp;&nbsp; Supported by Northeast University Data Science Team &
            Shenyang Huawei
            Shengteng</p>
        </div>
      </div>
    </el-footer>

  </el-container>


</template>

<style scoped lang="less">
.el-header {
  width: 100% !important;
  position: fixed !important;
  top: 0 !important;
  z-index: 1000 !important;
}

.myHead {
  margin-top: 0;
  margin-left: 65%;
  font-family: PingFang SC, serif;
}

.el-dropdown-link {
  color: #FFFFFF;//DD7700\18B084
  text-align: center;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin-top: 10px;
}

.el-main {
  padding: 0 !important;
  margin: 0 !important;
}

.el-footer {
  padding: 0 !important;
  margin: 0 !important;

  .detail {
    color: #FFF;
    font-family: Manrope;
    font-size: 21px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px; /* 114.286% */
  }

  .el-divider {
    background-color: rgb(66, 70, 145) !important;
  }
}

.footer {
  background: url("@/assets/footer1.png") no-repeat center;
  width: 100%;
  height: 200px;
  background-size: cover;
}

.el-carousel__indicator {
  color: rgba(245, 115, 67, 1) !important;
}

.poster {
  background: url("@/assets/background2.png") no-repeat center;
  width: 100%;
  height: 768px;
  background-size: cover;
  //position: fixed;
}

.leftCharacterBox {
  width: 620px;
  position: absolute;
  margin-top: 8%;
  margin-left: 5%;

  .one {
    color: #FFF;
    font-family: PingFang SC, serif;
    font-size: 46px;
    font-style: normal;
    font-weight: 600;
    line-height: 40px; /* 150% */
    text-align: left;
  }

  .two {
    color: #A0B3E9;
    font-family: PingFang SC, serif;
    font-size: 20px;
    font-style: normal;
    font-weight: 400;
    line-height: 40px; /* 208.333% */
    text-align: left;
  }

  .btn {
    display: flex;
    padding: 13px 0;
    justify-content: left;
    align-items: center;
    gap: 10px;
    margin-top: 5%;

    .a {
      border-radius: 40px;
      background: rgba(245, 122, 74, 0.60);
      border: none;
      color: #FFF;
      font-family: PingFang SC, serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }

    .b {
      border-radius: 40px;
      background: rgba(2, 183, 121, 0.60);
      color: #FFF;
      font-family: PingFang SC, serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
      border: none;
    }

    .text {
      color: #FFF;
      font-family: PingFang SC, serif;
      font-size: 36px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
    }
  }
}

.rightCharacterBox {
  width: 600px;
  position: absolute;
  margin-top: 34%;
  margin-left: 54%;
  background: transparent;
  padding: 0;
  //border-color: rgb(103, 105, 164);
  border: none;


}

.context {

  .ct1 {
    height: 700px;
    margin: 3% 5%;


    .logo {
      margin-top: 3%;
      margin-left: 8%;
      width: 100%;

      span {
        color: #1D1D4F;
        font-family: Source Sans 3, serif;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
        letter-spacing: 0.24px;
        margin-left: 10px;
      }
    }

    .content2_Detail {
      text-align: left;
      margin: 2% 8%;

      color: #5E6B90;
      font-family: Source Sans 3, serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 400;
      line-height: 34px; /* 154.545% */
    }

  }

  .ct2 {
    background: rgba(242, 245, 255, 1);
    height: 680px;
    padding-top: 100px;

    .content {
      p {
        color: #637096;
        font-family: Manrope;
        font-size: 22px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }


  }

  .ct3 {
    background: rgba(242, 245, 255, 1);
    height: 680px;
    padding-top: 100px;

    .content {
      margin: 5% 10%;

      .a {
        color: #1F1F5B;
        text-align: center;
        font-family: PingFang SC, serif;
        font-size: 28px;
        font-style: normal;
        font-weight: bold;
        line-height: 31.2px; /* 111.429% */
        letter-spacing: 0.28px;
      }

      .a1 {
        color: #FFF;
        text-align: center;
        font-family: PingFang SC, serif;
        font-size: 28px;
        font-style: normal;
        font-weight: 500;
        line-height: 31.2px; /* 111.429% */
        letter-spacing: 0.28px;
      }

      .b {
        text-align: left;
        margin-left: 5%;
        width: 300px;
        color: #798198;
        font-family: PingFang SC, serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 150% */
      }

      .b1 {
        color: #FFF;
        text-align: left;
        font-family: PingFang SC, serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 30px; /* 150% */
      }
    }


  }

  .ct4 {
    height: 680px;
    padding-top: 100px;
    z-index: 1;
    background: rgba(242, 245, 255, 1);

    .content {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      .cardDetail {
        margin-top: 4%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 450px;
        background-color: transparent;

        .videoBtn {
          width: 80px;
          height: 80px;
          background: #1E34BA;
          border: none;
          color: white;
          font-size: 24px;
        }

      }

      .a {
        color: #1F1F5B;
        font-family: PingFang SC, serif;
        font-size: 28px;
        font-style: normal;
        font-weight: 600;
        line-height: 32.408px; /* 115.742% */
        letter-spacing: -0.56px;
        text-align: left;
      }

      .b {
        text-align: left;
        color: #798198;
        font-family: Manrope, serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        line-height: 32.408px; /* 162.038% */
        letter-spacing: -0.4px;
        margin-top: 5px;
      }

      .video {
        background: url("@/assets/videoBackground.png") no-repeat center;
        width: 734px; //650,700
        height: 461px; //408,429
        background-size: cover;

        .video-player {
          margin-top: 5%;
          margin-left: 5%;
          width: 90%;
          height: 90%;
          display: block;
        }

      }
      .video_url_button{

        background: rgb(26, 208, 176);
        color: #FFFFFF;
        font-weight: bold;
        height: 36px;
        margin-left: 10px;

      }

    }
  }

  .ct5 {
    margin-top: 5%;
    background: url("@/assets/processBackground.png") no-repeat center;
    width: 100%;
    height: 680px;
    background-size: cover;

    .content {
      .a {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .processDetailUp {
          width: 240px;
        }
      }

      .b {
        margin-top: 10%;
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .processDetailDown {
          width: 240px;
        }
      }

      .p1 {
        text-align: left;
        color: #1F1F5B;
        font-family: PingFang SC, serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 500;
        margin-top: 10px;
      }

      .p2 {
        text-align: left;
        color: #1F1F5B;
        font-family: PingFang SC, serif;
        font-size: 28px;
        font-style: normal;
        font-weight: 500;
        margin-top: 10px;
      }

      .p3 {
        text-align: left;
        color: #798198;
        font-family: PingFang SC, serif;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        margin-top: 10px;
      }


    }
  }

  .ct6 {
    height: 680px;
    padding-top: 100px;

    .content {
      .imgBlock {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        margin: 5% 4% 0 4%;
      }

      .ct6_detail {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        .ct6_title {
          color: #1F1F5B;
          font-family: Source Sans 3;
          font-size: 28px;
          font-style: normal;
          font-weight: 400;
          line-height: normal;
          letter-spacing: 0.28px;
          text-align: left;
        }

        .ct6_content {
          text-align: left;
          width: 280px;
          color: #798198;
          font-family: Source Sans 3;
          font-size: 18px;
          font-style: normal;
          font-weight: 400;
          line-height: 30px; /* 166.667% */
          letter-spacing: -0.72px;

        }

      }
    }

  }

}

.About_context {
  .About_ct1 {
    background: rgb(226, 231, 248);
    height: 800px;
    padding-top: 60px;

    .content {
      margin-top: 4%;
      margin-left: 8%;
      margin-right: 8%;

      .ct1_leftUp {
        display: flex;
        flex-direction: row;
      }

      .ct1_leftBottom {
        margin-left: 10px;

        div {
          color: #637096;
          font-family: Manrope;
          font-size: 20px;
          font-style: normal;
          font-weight: 500;
          line-height: 36px; /* 180% */
          text-align: left;
        }
      }

      .Team {
        color: #1F1F5B;
        font-family: Manrope;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 32.408px; /* 124.645% */
        text-align: left;
        margin-top: 0;
        margin-bottom: 15px;
      }

      .ct1_rightUp {
        .Team_detail {
          display: flex;
          flex-direction: row;
          align-items: center;

          span {
            color: #1F1F5B;
            font-family: Manrope;
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: 32.408px; /* 162.038% */
            letter-spacing: -0.4px;
            margin-left: 10px;
          }
        }

        .Team_content {
          color: #637096;
          font-family: Manrope;
          font-size: 18px;
          font-style: normal;
          font-weight: 500;
          line-height: 32.408px; /* 162.038% */
          letter-spacing: -0.4px;
          text-align: left;
          margin: 3% 0;
        }


      }

      .ct1_rightBottom {

        .developTeam {
          text-align: left;

          span {
            color: #637096;
            font-family: Manrope;
            font-size: 18px;
            font-style: normal;
            font-weight: 500;
            line-height: normal;
            margin-left: 10px;
          }

        }

      }

    }
  }

  .About_ct2 {
    margin-top: 3%;
    width: 100%;
    height: 720px;
    background: url("@/assets/AboutUs_ct2_background.png") no-repeat center;
    height: 680px;
    background-size: cover;

    .content {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      margin: 2% 10%;
    }

    .About_ct2_card {
      width: 500px;
      height: 450px;
      border-radius: 10px;
      border: 1px solid #D9E5FB;
      background: #F9FAFF;
    }

    .About_ct2_left {
      color: #637096;
      font-family: Manrope;
      font-size: 18px;
      font-style: normal;
      font-weight: 400;
      line-height: 36px; /* 180% */
      letter-spacing: -0.4px;
      text-align: left;
    }
  }

  .ct3_ContactUs {
    background: url("@/assets/ct3_ContactUs.png") no-repeat center;
    width: 80%;
    height: 200px;
    margin-top: -6%;
    margin-left: 10%;
    margin-right: 10%;
    background-size: cover;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  .contribution {
    color: #1F1F5B;
    font-family: Manrope;
    font-size: 22px;
    font-style: normal;
    font-weight: 500;
    line-height: 32.408px; /* 135.032% */
    letter-spacing: -0.48px;

  }


}

/deep/ .el-carousel__button {
  background-color: #F57343 !important;
  height: 4px !important;
}

/deep/ .vjs-big-play-button {
  background: #F57A4A !important;
  border-radius: 1.8em !important;
  height: 1.8em !important;
  width: 1.8em !important;
}


</style>